export const formatSalaryAmount = ({
  amount,
  currency,
  locale
}: {
  amount: number;
  currency: string;
  locale: string;
}) => {
  if (amount === undefined || amount === null) return '';

  const numberFormatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 0
  });

  return numberFormatter.format(amount);
};
